(() => {
	let e = window.Difrax?.sectionLifecycle;
	if (!e) return;
	let t = (e) => {
			let t = e.querySelector(`[data-seo-rich-text-content]`),
				n = e.querySelector(`[data-seo-rich-text-toggle]`);
			if (!t || !n) return;
			let r = e.dataset.expanded === `true`,
				i = n.dataset.collapsedLabel || n.textContent,
				a = n.dataset.expandedLabel || i;
			if (
				((e.dataset.expanded = `false`),
				(e.dataset.collapsible = `true`),
				(n.hidden = !0),
				n.setAttribute(`aria-expanded`, `false`),
				(n.textContent = i),
				!(t.scrollHeight > t.clientHeight + 1))
			) {
				e.dataset.collapsible = `false`;
				return;
			}
			if (r) {
				(e.dataset.expanded = `true`),
					(n.hidden = !1),
					n.setAttribute(`aria-expanded`, `true`),
					(n.textContent = a);
				return;
			}
			n.hidden = !1;
		},
		n = (e) => {
			if (e.dataset.seoRichTextInitialized === `true`) {
				t(e);
				return;
			}
			(e.dataset.seoRichTextInitialized = `true`),
				t(e),
				e
					.querySelector(`[data-seo-rich-text-toggle]`)
					?.addEventListener(`click`, () => {
						let t = e.querySelector(`[data-seo-rich-text-toggle]`);
						if (!t) return;
						let n = e.dataset.expanded !== `true`,
							r = t.dataset.collapsedLabel || t.textContent,
							i = t.dataset.expandedLabel || r;
						(e.dataset.expanded = String(n)),
							(t.hidden = !1),
							t.setAttribute(`aria-expanded`, String(n)),
							(t.textContent = n ? i : r);
					});
		},
		r = (e) => {
			e.querySelectorAll(`[data-seo-rich-text]`).forEach(n);
		};
	e.register({
		name: `seo-content`,
		selector: `.seo-content`,
		init: r,
		update: r,
	});
})();
